(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */

        (function initBannerSlider() {
            var root = document.querySelector('.banner-slider .bannerSwiper');

            if (!root || typeof Swiper === 'undefined') {
                return;
            }

            var count = parseInt(root.getAttribute('data-count'), 10) || 0;
            var isLoop = count > 1;

            new Swiper(root, {
                loop: isLoop,
                speed: 800,
                autoplay: isLoop ? {
                    delay: 4000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true
                } : false,
                navigation: {
                    nextEl: '.banner-slider .swiper-button-next',
                    prevEl: '.banner-slider .swiper-button-prev'
                },
                pagination: {
                    el: '.banner-slider .swiper-pagination',
                    clickable: true
                }
            });
        })();
    }, {}] }, {}, [1]);